import React from "react";
import { primaryColor } from "../../../Theme";

interface UserIconProps {
  color?: string;
}

const UserIcon: React.FC<UserIconProps> = ({ color = primaryColor }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ minWidth: "24px", minHeight: "24px" }}
  >
    <path
      d="M4 17.8C4.46117 17.2835 6.62105 14.9067 7.25401 14.9067H13.9464C14.8636 14.9067 16.736 16.8769 17.2 17.5714M20.2 10.6C20.2 15.9019 15.9019 20.2 10.6 20.2C5.29807 20.2 1 15.9019 1 10.6C1 5.29807 5.29807 1 10.6 1C15.9019 1 20.2 5.29807 20.2 10.6ZM14.0388 7.32796C14.0388 5.49645 12.4927 4 10.6003 4C8.70791 4 7.16174 5.49645 7.16174 7.32796C7.16174 9.15947 8.70791 10.6559 10.6003 10.6559C12.4927 10.6559 14.0388 9.15947 14.0388 7.32796Z"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

export default UserIcon;

